/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./OverviewDemand.vue?vue&type=template&id=260c0fcc&scoped=true&"
import script from "./OverviewDemand.vue?vue&type=script&lang=js&"
export * from "./OverviewDemand.vue?vue&type=script&lang=js&"
import style0 from "./OverviewDemand.vue?vue&type=style&index=0&id=260c0fcc&prod&lang=scss&scoped=true&"
import style1 from "./OverviewDemand.vue?vue&type=style&index=1&id=260c0fcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260c0fcc",
  null
  
)

export default component.exports